import { TAG_APPOINTMENT_GET_PATIENT_SOURCES } from '@shared/services/appointment/newPatient/endpoints/getPatientSources';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_USER_PROFILE_PATIENT_MASTER_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { PROFILE_PATIENT_MASTER_TAGS } from './getProfilePatientMaster';
import type { CreateUpdateProfilePatientMasterResult } from '../types/createProfilePatientMaster.types';
import type { UpdateProfilePatientMasterPayload } from '../types/updateProfilePatientMaster.types';

export const updateProfilePatientMaster = (builder: BuilderType) =>
  builder.mutation<CreateUpdateProfilePatientMasterResult, UpdateProfilePatientMasterPayload>({
    invalidatesTags: [PROFILE_PATIENT_MASTER_TAGS, TAG_APPOINTMENT_GET_PATIENT_SOURCES],
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_USER_PROFILE_PATIENT_MASTER_URL,
    }),
    transformResponse: (response: GenericApiResponse<CreateUpdateProfilePatientMasterResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
